import setLocale from '@/locale';
import i18n from '@/plugins/i18n';
import hc from 'highcharts';
import HighchartsVue from 'highcharts-vue';
import Boost from 'highcharts/modules/boost';
import Exporting from 'highcharts/modules/exporting';
import highCharts from 'src/plugins/high-charts';
import quasar from 'src/plugins/quasar';
import 'src/styles/index.styl';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
Boost(hc);
Exporting(hc);
const lang = process.env.VUE_APP_CLOUD_I18N_LOCALE || 'en';
setLocale(lang);
Vue.config.productionTip = false;
quasar({ Vue });
highCharts(lang);
Vue.use(HighchartsVue);
new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
